import CompanyManagement from './pages/admin/CompanyManagement';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './components/layout/AppLayout';
import { ProtectedRoute } from './components/Auth/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import AdminLayout from './pages/admin/AdminLayout';
import LayerManagement from './pages/admin/LayerManagement';
import CacheManagement from './pages/admin/CacheManagement';
import RoutingManagement from './pages/admin/RoutingManagement';
import TaxonomyPage from './pages/admin/taxonomy/TaxonomyPage';
import FlowsPage from './pages/admin/taxonomy/FlowsPage';
import UsersPage from './pages/UsersPage';
import './App.css';

function App() {
  return (
    <div className="app-container w-screen h-screen">
      <Routes>
        {/* Public route */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected map route */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        />

        {/* The company's own people (its administrator) */}
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <UsersPage />
            </ProtectedRoute>
          }
        />

        {/* Admin routes */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute requiredAuthority="ROLE_ADMIN">
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<LayerManagement />} />
          <Route path="layers" element={<LayerManagement />} />
          <Route path="companies" element={<CompanyManagement />} />
          <Route path="cache" element={<CacheManagement />} />
          <Route path="routing" element={<RoutingManagement />} />
          <Route path="taxonomy" element={<TaxonomyPage />} />
          <Route path="flows" element={<FlowsPage />} />
        </Route>

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
